import { makeAutoObservable } from "mobx";
import { SearchObject } from "app/common/Model/SearchObject";
import {
    deleteIngusionFormula,
    findListIngusionFormula,
    getAllIngusionFormula,
    getIngusionFormulaById,
    pagingIngusionFormula,
    saveIngusionFormula
} from 'app/services/IngusionFormulaService';
import { IngusionFormula } from "app/common/Model/IngusionFormula";
import { checkSearchObject } from "app/common/LocalFunction";
import { toast } from "react-toastify";

export default class IngusionFormulaStore {
    listAllIngusionFormula = [];
    searchIngusionFormula = new SearchObject();
    pageIngusionFormula = null;
    selectedIngusionFormula = null;
    openFormCreateOrEdit = false;
    openConfirmDeleteIngusionFormula = false;
    recentlyUpdated = false;
    listIngusionFormula = [];

    constructor() {
        makeAutoObservable(this);
    }

    getAllIngusionFormula = () => {
        if (this.listAllIngusionFormula?.length === 0 || this.recentlyUpdated) {
            getAllIngusionFormula()
                .then(({ data }) => {
                    this.listAllIngusionFormula = data;
                    this.recentlyUpdated = false;
                })
                .catch((error) => {
                    console.error(error);
                    toast.error("Lấy dữ liệu có lỗi");
                });
        }
    }

    pagingIngusionFormula = async () => {
        return await pagingIngusionFormula(this.searchIngusionFormula)
            .then(({ data }) => {
                this.pageIngusionFormula = data;
            })
            .catch((error) => {
                console.error(error);
                toast.error("Lấy dữ liệu có lỗi");
            })
    }

    handleChangeFormSearch = (searchIngusionFormula) => {
        this.searchIngusionFormula = checkSearchObject(this.searchIngusionFormula, searchIngusionFormula);
        this.pagingIngusionFormula();
    }

    handleOpenFormCreateOrEdit = (ingusionFormulaId) => {
        if (Boolean(ingusionFormulaId)) {
            getIngusionFormulaById(ingusionFormulaId)
                .then(({ data }) => {
                    this.selectedIngusionFormula = data;
                    this.openFormCreateOrEdit = true;
                })
                .catch((error) => {
                    console.error(error);
                    toast.error("Lấy dữ liệu có lỗi");
                })
        } else {
            this.selectedIngusionFormula = new IngusionFormula();
            this.openFormCreateOrEdit = true;
        }
    }

    saveIngusionFormula = async (ingusionFormula, { setSubmitting }) => {
        return await saveIngusionFormula(ingusionFormula)
            .then(() => {
                this.recentlyUpdated = true;
                this.selectedIngusionFormula = null;
                toast.success("Lưu nhóm thuốc thành công!");
                this.handleClosePopup();
                this.pagingIngusionFormula();
            })
            .catch(error => {
                console.error(error);
                toast.error("Lưu thông tin nhóm thuốc có lỗi");
            })
            .finally(() => setSubmitting(false))
    }

    handleDeleteIngusionFormula = (ingusionFormula) => {
        this.selectedIngusionFormula = { id: ingusionFormula?.id };
        this.openConfirmDeleteIngusionFormula = true;
    }

    handleConfirmDeleteIngusionFormula = () => deleteIngusionFormula(this?.selectedIngusionFormula?.id)
        .then(() => {
            if (this.searchIngusionFormula.pageIndex > 1 && this.pageIngusionFormula?.content?.length === 1) {
                this.searchIngusionFormula.pageIndex -= 1;
            }
            toast.success("Xóa nhóm thuốc thành công!")
            this.handleClosePopup();
            this.recentlyUpdated = true;
            this.pagingIngusionFormula();
        })
        .catch(err => {
            console.error(err);
            toast.error("Xóa nhóm thuốc có lỗi");
        })

    handleClosePopup = () => {
        this.openFormCreateOrEdit = false;
        this.openConfirmDeleteIngusionFormula = false;
    }

    findListIngusionFormula = async (ingusionFormula) => {
        return await findListIngusionFormula(ingusionFormula)
            .then(({ data }) => {
                this.listIngusionFormula = data || [];
                if (data?.length === 0) toast.warning("Chưa có thuốc nào được pha chế từ danh sách thuốc đã chọn")
            })
            .catch(error => {
                console.error(error);
                toast.error("Chưa có thuốc được bào chế từ những thuốc này.");
            })
    }

    resetStore = () => {
        this.searchIngusionFormula = new SearchObject();
        this.pageIngusionFormula = null;
        this.selectedIngusionFormula = null;
        this.openFormCreateOrEdit = false;
        this.openConfirmDeleteIngusionFormula = false;
    }
}